// Crisp 客服系统配置文件
// 文档: https://docs.crisp.chat/guides/chatbox-sdks/web-sdk/dollar-crisp/

/**
 * Crisp Website ID 配置
 * 根据环境或 A/B 测试需求返回不同的 Website ID
 */
export const getCrispWebsiteId = () => {
  // 优先使用环境变量
  if (process.env.GATSBY_CRISP_WEBSITE_ID) {
    return process.env.GATSBY_CRISP_WEBSITE_ID
  }

  // 默认 Website ID (请替换为你的实际 ID)
  return 'YOUR_CRISP_WEBSITE_ID'
}

/**
 * A/B 测试配置
 * 可以根据用户分组返回不同的 Crisp 配置
 */
export const getCrispConfig = () => {
  // 检查是否启用 A/B 测试
  const enableABTest = process.env.GATSBY_CRISP_AB_TEST_ENABLED === 'true'

  if (!enableABTest) {
    return {
      websiteId: getCrispWebsiteId(),
      variant: 'default',
    }
  }

  // A/B 测试逻辑: 50/50 分流
  // 使用 localStorage 保持用户分组一致性
  if (typeof window !== 'undefined') {
    let variant = localStorage.getItem('crisp_ab_variant')

    if (!variant) {
      // 随机分配 A 或 B 组
      variant = Math.random() < 0.5 ? 'A' : 'B'
      localStorage.setItem('crisp_ab_variant', variant)
    }

    // 根据不同组返回不同的 Website ID (可选)
    const websiteIds = {
      A: process.env.GATSBY_CRISP_WEBSITE_ID_A || getCrispWebsiteId(),
      B: process.env.GATSBY_CRISP_WEBSITE_ID_B || getCrispWebsiteId(),
    }

    return {
      websiteId: websiteIds[variant],
      variant,
    }
  }

  // SSR 环境返回默认配置
  return {
    websiteId: getCrispWebsiteId(),
    variant: 'default',
  }
}

/**
 * Crisp 自动回复配置
 * 可以通过 Crisp SDK 设置自动回复消息
 */
export const crispAutoResponderConfig = {
  // 欢迎消息 (可选 - 也可以在 Crisp Dashboard 中配置)
  welcomeMessage: 'Hi! 👋 How can we help you today?',

  // 常见问题自动回复
  autoResponses: [
    {
      trigger: ['price', 'pricing', 'cost', 'how much'],
      response:
        'You can find our pricing information at https://yoursite.com/pricing',
    },
    {
      trigger: ['shipping', 'delivery'],
      response: 'We offer free shipping on orders over $50!',
    },
    {
      trigger: ['return', 'refund'],
      response:
        'Our return policy allows returns within 30 days. Check our policy at https://yoursite.com/returns',
    },
  ],

  // 离线消息
  offlineMessage:
    "We're currently offline, but we'll get back to you as soon as possible!",
}

/**
 * Crisp 自定义配置选项
 */
export const crispCustomConfig = {
  // 颜色主题
  colorTheme: 'blue', // 可选: blue, red, green, purple, orange, pink

  // 是否隐藏在移动端
  hideOnMobile: false,

  // 默认是否展开
  defaultExpanded: false,

  // 位置 (left/right)
  position: 'right',

  // 本地化语言
  locale: 'en', // 可选: en, zh-CN, zh-TW, ja, ko 等
}
